import { Notification } from '@alifd/next';

export default {
  success(content, title = '成功') {
    Notification.open({
      title,
      content,
      icon: 'success-filling',
    });
  },
  error(content, title = '失败') {
    Notification.open({
      title,
      content,
      type: 'error',
      icon: 'delete-filling',
    });
  },
};
